import type { RangeSelection } from './types';

export function calculateDistance(
  nodeIndex: number,
  selection: RangeSelection,
  punctuationMarkers: boolean[]
): number {
  // Overlapping
  if (nodeIndex >= selection.startIndex && nodeIndex <= selection.endIndex) {
    return -1;
  }

  // Node to the left
  if (nodeIndex < selection.startIndex) {
    for (let i = nodeIndex; i < selection.startIndex && i < punctuationMarkers.length; i++) {
      if (punctuationMarkers[i]) return 1000;
    }
    return selection.startIndex - nodeIndex - 1;
  }

  // Node to the right
  for (let i = selection.endIndex; i < nodeIndex && i < punctuationMarkers.length; i++) {
    if (punctuationMarkers[i]) return 1000;
  }
  return nodeIndex - selection.endIndex - 1;
}

export function findSentenceBoundaries(
  startIndex: number,
  endIndex: number,
  punctuationMarkers: boolean[]
): number[] {
  const boundaries: number[] = [];
  for (let i = startIndex; i < endIndex && i < punctuationMarkers.length; i++) {
    if (punctuationMarkers[i]) boundaries.push(i);
  }
  return boundaries;
}

export type SelectionAction = 'createNew' | 'extend' | 'bridge' | 'deselect';

export interface SelectionResult {
  action: SelectionAction;
  newSelection?: RangeSelection;
  oldSelection?: RangeSelection;
  leftSelection?: RangeSelection;
  rightSelection?: RangeSelection;
  mergedSelection?: RangeSelection;
}
